import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { Annonce } from '../../common/models/annonce';
import { AttributionFromFNSimple } from './models/AttributionFromFNSimple';
import { AttributionFromFnsimpleService } from './services/attributionFromFromFnsimple/attribution-from-fnsimple.service';
import { CommonService } from '../../common/services/common/common.service';
import { FnsimpleService } from '../common/services/fnsimple.service';
import { FNSimple } from '../common/models/FNSimple';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class FormfnsAttributionExtractorService {
  constructor(private formExtractorService: FormExtractorService,
    private attributionFromFnsimpleService: AttributionFromFnsimpleService,
    private commonService: CommonService, private fnsimpleService: FnsimpleService,
    private avisDataTransferService: AvisDataTransferService) { }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

    const attributionFromFNSimple = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.attribution;

    attributionFromFNSimple.pasAvisInitial = controls.get('_SepSep_AttributionFromFNSimple_SepAtt_pasAvisInitial');
    if (stepId === 5) {
      attributionFromFNSimple.attributionMarche = controls.get('_SepSep_AttributionFromFNSimple_SepAtt_attributionMarche');
    }

    if (stepId === 1) {
      attributionFromFNSimple.avisInitial =
        this.attributionFromFnsimpleService.avisInitialService.getAvisInitial(
          controls
        );
    }
    if (stepId === 3 || stepId === 4) {
      attributionFromFNSimple.natureMarche =
        this.attributionFromFnsimpleService.natureMarcheService.getNatureMarche(
          controls, stepId
        );
    }
      const fnSimple: FNSimple = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple;
      if (stepId === 2) {
        fnSimple.organisme = this.fnsimpleService.organismeService.getOrganisme(controls);
      }
      fnSimple.initialFromFNSimple = null;
      fnSimple.attribution = attributionFromFNSimple;
      fnSimple.rectificatifFromFNSimple = null;
      fnSimple.annulationFromFNSimple = null;

      const annonce: Annonce = new Annonce();
      annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
      annonce.ann.divers = null;
      annonce.ann.mapa = null;
      annonce.ann.fnSimple = fnSimple;
      annonce.ann.formAD = null;
      annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
      annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
      annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

      annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
      annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
    //Nettoyer les blocs inexistants
    const avis: Avis = new Avis();
    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.SIMP_AT];
    avis.statut = StatutAvisEnum.ELABORE;
    avis.critere.typeAvis.code=TypeAvisEnum.C4_3;
    return avis;
  }
}
